import { FormLabel, InputGroup } from "react-bootstrap";
import { IFieldEditor } from "../../../../models/Interfaces";
import InputGroupText from "react-bootstrap/esm/InputGroupText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';

const DateEditor = (props: IFieldEditor) => {

  const onInputChange = (selected: Date | null) : void => {
    if (selected) {
      props.onValueChange(props.property.Id, selected.toString());
    } else {
      props.onValueChange(props.property.Id, "");
    }
  }

  return (
    <>
      <FormLabel>{props.property.DisplayLabel}</FormLabel>
      <InputGroup>
        <InputGroupText>
          <FontAwesomeIcon icon={faCalendar} />
        </InputGroupText>
        <DatePicker
          onChange={onInputChange}
          value={props.property.PublishedValue || props.property.DefaultValue || ""}
          dateFormat="dd-MM-yyyy"
          placeholderText={`select ${props.property.DisplayLabel?.toLowerCase() ?? "date"}...`}
          selected={props.property.DefaultValue ? new Date(props.property.DefaultValue) : null}>
        </DatePicker>
      </InputGroup>
    </>
  );
}

export default DateEditor;